import { FunctionComponent } from 'react';

export type SeparatorImgProps = {
  width: number;
  height: number;
  fill: string;
};

type FC = FunctionComponent<SeparatorImgProps>;

const SeparatorImg: FC = (props: SeparatorImgProps) => {
  const { width, height, fill } = props;

  return (
    <svg width={`${width}%`} height={`${height}%`} viewBox="0 0 721 924" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M684.5 -125L660.5 -25C636.5 75 588.5 275 594.5 475C600.5 675 660.5 875 690.5 975L720.5 1075L-56.0001 1075L-56 975C-56 875 -56 675 -56 475C-56 275 -56 75 -56 -25L-56 -125L684.5 -125Z"
        fill="#FFD147"
      />
      <path
        d="M307.25 470.25L332 437.25L356.75 474.375V462H389.75V404.25C389.75 395.15 382.35 387.75 373.25 387.75H266C256.9 387.75 249.5 395.15 249.5 404.25V503.25C249.5 512.35 256.9 519.75 266 519.75H332V486.75H274.25L299 453.75L307.25 470.25Z"
        fill="white"
      />
      <path
        d="M389.75 478.5H373.25V503.25H348.5V519.75H373.25V544.5H389.75V519.75H414.5V503.25H389.75V478.5Z"
        fill={fill}
      />
    </svg>
  );
};

export default SeparatorImg;
